import template from './batchCancel.html';
import controller from './batchCancel.controller';

let batchCancelComponent = {
  restrict: 'E',
  bindings: {
    batchId: '='
  },
  template,
  controller,
  controllerAs: 'vm'
};

export default batchCancelComponent;



// WEBPACK FOOTER //
// ./app/components/batchCancel/batchCancel.component.js